import { render, staticRenderFns } from "./Menu2.vue?vue&type=template&id=54f3cd20&scoped=true"
import script from "./Menu2.vue?vue&type=script&lang=js"
export * from "./Menu2.vue?vue&type=script&lang=js"
import style0 from "./Menu2.vue?vue&type=style&index=0&id=54f3cd20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3cd20",
  null
  
)

export default component.exports